import React from "react";

function Suport(){
    return(
        <div>
<section className="internal_wraper">
<div className="container">
<div className="row">
    <div className="col-12 mt-5 pt-5">
<h1 className="font-weight-bold">
Suport
</h1>
    </div>
</div>
</div>
</section>
        </div>
    );
};

export default Suport;